import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";
import Forbidden from "../pages/Forbidden";
import { UpgradeNotice } from "./LockedFeature";

// Protection UX (le backend reste l'autorité absolue).
//  - requirePermission : clé feature Phase 1. HIDDEN -> 403 ; LOCKED -> écran Upgrade ; GRANTED -> ok.
//  - requireProfile    : rôle requis dans identity.profiles (sinon 403).
export function ProtectedRoute({ children, requireOnboarded = true, requirePermission = null, requireProfile = null }) {
  const { user, identity, featureState } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0C]">
        <Loader2 className="w-8 h-8 text-amber-500 animate-spin" />
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  if (requireOnboarded && !user.onboarded) return <Navigate to="/onboarding" replace />;

  // Gardes basées sur l'identité résolue (Phase 1). Tant que l'identité charge, on laisse
  // passer : le backend reste l'autorité et bloque toute donnée non autorisée.
  if (identity) {
    if (requireProfile && !(identity.profiles || []).includes(requireProfile)) {
      return <Forbidden />;
    }
    if (requirePermission) {
      const st = featureState(requirePermission);
      if (st === "HIDDEN") return <Forbidden />;
      if (st === "LOCKED") return <UpgradeNotice feature={requirePermission} />;
    }
  }
  return children;
}
